import React, { useState, useRef, useEffect } from 'react';
import PropsType from 'prop-types';
import { cloneDeep } from 'lodash';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import { toast } from 'react-toastify';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import arrayMove from 'array-move';
import RouteName from '../../App/RouteNames';
import { modifyApprovals, getApprovals } from '../actions';
import { GenericInput, TitleFrom, Breadcrumb, DataTablDragDrop } from '../../../components/common';
import ModalUserGroup from '../../../components/common/ModalUserGroup';
import ModalReasonCodeConfig from '../../../components/common/ModalReasonCodeConfig';
import { makeGetPermissionsArOpsManagement } from '../../App/selectors';
import { checkPermissionModifyConfigApprovals } from '../CheckPermission';

const ApprovalsModify = ({ modifyApprovals, getApprovals, history, permissionsArOps }) => {
  const { t } = useTranslation('common');
  const [itemSelect, setItemSelect] = useState(null);
  const [indexSelect, setIndexSelect] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [id, setId] = useState(null);
  const [isOpenReasonCode, setIsOpenReasonCode] = useState(false);
  const [data, setData] = useState({ reasonCode: '', objectType: '', customReasonCode: '', approvalLevels: [] });
  const [modifyData, setModifyData] = useState(null);
  const [wasValidated, setValidate] = useState(false);
  const formRef = useRef();

  const validate = (out = false) => {
    const formValid = formRef && formRef.current.checkValidity();
    const { elements } = formRef.current;
    for (let i = 0; i < elements.length; i++) {
      if (!elements[i].validity.valid) {
        console.log(elements[i].name, 'invalid');
      }
    }
    if (!formValid && out) {
      toast.error(t('message.mandatory'));
    }
    return formValid;
  };

  useEffect(() => {
    getApprovals(({ success, data }) => {
      // if (success) {
      //   setModifyData(data);
      // }
      if (success && data && data.id) {
        setModifyData(data.approvalObjects);
        setId(data.id);
      }
    });
  }, [getApprovals]);

  let modeModifyConfigApprovals = 0;

  if (permissionsArOps && permissionsArOps.arOpsModulePermissions) {
    const listPermission = permissionsArOps.arOpsModulePermissions;
    modeModifyConfigApprovals = checkPermissionModifyConfigApprovals({ listPermission });
  }
  if (!modeModifyConfigApprovals) return '';

  const onSelect = (id, row) => {
    const newData = cloneDeep(data);
    newData.approvalLevels[indexSelect].userGroupId = row && row.groupId ? row.groupId : '';
    newData.approvalLevels[indexSelect].userGroupName = row && row.groupName ? row.groupName : '';
    setData(newData);
    setIsOpen(false);
  };

  const onRemoveUser = index => {
    const newData = cloneDeep(data);
    newData.approvalLevels.splice(index, 1);
    setData(newData);
  };

  const onSelectReason = (val, row) => {
    const newData = cloneDeep(data);
    newData.customReasonCode = row.customReasonCode || '';
    setData(newData);
    setIsOpenReasonCode(false);
  };

  const onChangeTable = ({ name, value, index }) => {
    try {
      const newData = cloneDeep(data);
      let newValue = value;
      if (newValue === 'TRUE' || newValue === 'FALSE') newValue = newValue === 'TRUE' ? 'true' : 'false';
      newData.approvalLevels[index][name] = newValue;
      setData(newData);
    } catch (error) {
      console.log(error);
    }
  };

  const headerTable = [
    {
      name: 'userGroupId',
      label: 'label.userGroupId',
      required: true,
      render: (colName, item, idx) => (
        <GenericInput
          value={item.userGroupId}
          wrapperClass="col-md-12"
          onChange={({ name, value }) => this.onChangeTable({ name, value, id: item.id })}
          name="userGroupId"
          fa="fa fa-external-link"
          onClick={() => {
            setIsOpen(true);
            setItemSelect(item);
            setIndexSelect(idx);
          }}
          required
        />
      ),
    },
    {
      name: 'userGroupName',
      label: 'label.userGroupName',
      render: (colName, item, idx) => (
        <GenericInput
          value={item.userGroupName}
          wrapperClass="col-md-12"
          onChange={({ name, value }) => {}}
          name="userGroupName"
          readOnly
        />
      ),
    },
    {
      name: 'approvalRequired',
      label: 'label.approvalRequired',
      render: (colName, item, idx) => (
        <GenericInput
          value={item.approvalRequired === 'true' || item.approvalRequired === true ? 'TRUE' : 'FALSE'}
          wrapperClass="col-md-12"
          onChange={({ name, value }) => onChangeTable({ name, value, index: idx })}
          name="approvalRequired"
          type="select"
          tOptions="selections:selectBool"
          menuPortalTarget
        />
      ),
    },
    {
      name: 'approvalCorrespondence',
      label: 'label.approvalCorrespondence',
      render: (colName, item, idx) => (
        <GenericInput
          value={item.approvalCorrespondence === 'true' || item.approvalCorrespondence === true ? 'TRUE' : 'FALSE'}
          wrapperClass="col-md-12"
          onChange={({ name, value }) => onChangeTable({ name, value, index: idx })}
          name="approvalCorrespondence"
          type="select"
          tOptions="selections:selectBool"
          menuPortalTarget
        />
      ),
    },
    {
      name: 'rejectionCorrespondence',
      label: 'label.rejectionCorrespondence',
      render: (colName, item, idx) => (
        <GenericInput
          value={item.rejectionCorrespondence === 'true' || item.rejectionCorrespondence === true ? 'TRUE' : 'FALSE'}
          wrapperClass="col-md-12"
          onChange={({ name, value }) => onChangeTable({ name, value, index: idx })}
          name="rejectionCorrespondence"
          type="select"
          tOptions="selections:selectBool"
          menuPortalTarget
        />
      ),
    },
    {
      name: 'remove',
      label: 'label.remove',
      render: (colName, item, idx) => {
        return (
          <div className="form-group col-md-12">
            <button type="button" className="btn-phone" onClick={() => onRemoveUser({ index: idx })}>
              <i className="fa fa-trash" />
            </button>
          </div>
        );
      },
    },
  ];

  const onChange = ({ name, value }) => {
    const newData = cloneDeep(data);
    newData[name] = value;
    setData(newData);
  };

  const onHandleAddUser = () => {
    const newData = cloneDeep(data);
    let lastIndex = 0;
    newData.approvalLevels.forEach(val => {
      if (val.index > lastIndex) lastIndex = val.index;
    });
    newData.approvalLevels.push({
      index: lastIndex + 1,
      userId: '',
      approvalRequired: 'true',
      approvalCorrespondence: 'true',
      rejectionCorrespondence: 'true',
    });
    setData(newData);
  };

  const onSubmit = evt => {
    evt.preventDefault();
    let lastIndex = 0;
    const newData = cloneDeep(data);
    setValidate(true);
    if (!validate(true)) {
      return false;
    }
    if (newData.customReasonCode) delete newData.reasonCode;
    if (newData.reasonCode) delete newData.customReasonCode;
    modifyData.forEach(val => {
      if (val.index > lastIndex) lastIndex = val.index;
    });
    newData.approvalLevels = newData.approvalLevels.map(val => {
      const { userGroupId, index, approvalRequired, approvalCorrespondence, rejectionCorrespondence } = val;
      return { userGroupId, index, approvalRequired, approvalCorrespondence, rejectionCorrespondence };
    });
    modifyApprovals({ approvalObjects: [{ ...newData, index: lastIndex + 1 }], id: id || '' }, ({ success }) => {
      if (success) history.push(RouteName.userManagementApproval.path);
    });
  };

  const onSortEndAdvertisement = ({ oldIndex, newIndex }) => {
    const newData = cloneDeep(data);
    const orderedJobList = arrayMove(newData.approvalLevels, oldIndex, newIndex);
    newData.approvalLevels = orderedJobList;
    setData(newData);
  };

  const onCancel = () => {
    setData({ reasonCode: '', objectType: '', customReasonCode: '', approvalLevels: [] });
  };

  return (
    <div>
      <div className="page-title">
        <div className="row">
          <div className="col-sm-6">
            <NavLink className="button x-small" to={RouteName.userManagementApproval.path}>
              {t('label.back')}
            </NavLink>
          </div>
          <div className="col-sm-6">
            <Breadcrumb
              items={[
                {
                  name: t('userManagementPage:sidebar.approvals'),
                  url: RouteName.userManagementApproval.path,
                },
              ]}
            />
          </div>
        </div>
      </div>
      <br />
      <form
        ref={formRef}
        noValidate
        className={`col-md-12 p-2 card card-statistics needs-validation ${wasValidated ? 'was-validated' : ''}`}
        // onSubmit={onHandleSubmit}
        onSubmit={onSubmit}
      >
        <div className="d-block d-md-flex">
          <div className="d-block d-md-flex clearfix sm-mt-20 ">
            <TitleFrom title={t('label.addNewApproval')} />
          </div>
        </div>
        <div className="col-md-12 p-2 row">
          <GenericInput
            value={data.objectType}
            label="label.objectType"
            wrapperClass="col-md-4"
            onChange={({ name, value }) => onChange({ name, value })}
            name="objectType"
            type="select"
            tOptions="selections:objectTypeApproval"
            menuPortalTarget
          />
          <GenericInput
            value={data.reasonCode}
            label="label.reasonCode"
            wrapperClass="col-md-4"
            onChange={({ name, value }) => onChange({ name, value })}
            name="reasonCode"
            disabled={!!data.customReasonCode}
            isClearable
            type="select"
            tOptions="selections:reasonConfig"
            menuPortalTarget
          />
          <GenericInput
            value={data.customReasonCode}
            label="label.customReason"
            disabled={!!data.reasonCode}
            wrapperClass="col-md-4"
            onChange={({ name, value }) => onChange({ name, value })}
            name="customReasonCode"
            fa="fa fa-external-link"
            onClick={() => setIsOpenReasonCode(true)}
          />
        </div>
        <br />
        <div className="col-md-12">
          <DataTablDragDrop columns={headerTable} data={data.approvalLevels || []} onSortEnd={onSortEndAdvertisement} />
        </div>
        <div className="form-group col-md-12 buttons-attibute">
          <button type="button" className="button button-border black x-small" onClick={onHandleAddUser}>
            +
            {t('label.addAnotherApprovalLevel')}
          </button>
          {modeModifyConfigApprovals === 2 && (
            <button
              type="submit"
              className="button button-border x-small float-right"
            >
              {t('label.create')}
            </button>
          )}
          <button onClick={onCancel} type="button" className="button button-border black x-small float-right">
            {t('label.cancel')}
          </button>
        </div>
      </form>
      <ModalReasonCodeConfig
        isOpen={isOpenReasonCode}
        onSelect={onSelectReason}
        onCancel={() => setIsOpenReasonCode(false)}
        selectedParentId={data ? data.reasonCode : null}
      />
      <ModalUserGroup
        isOpen={isOpen}
        onSelect={onSelect}
        onCancel={() => setIsOpen(false)}
        selectedParentId={itemSelect ? itemSelect.groupId : null}
      />
    </div>
  );
};

ApprovalsModify.propTypes = {
  modifyApprovals: PropsType.func.isRequired,
  getApprovals: PropsType.func.isRequired,
};

ApprovalsModify.defaultProps = {};

const mapStateToProps = createStructuredSelector({
  permissionsArOps: makeGetPermissionsArOpsManagement() || {},
});

export default connect(mapStateToProps, { modifyApprovals, getApprovals })(ApprovalsModify);
